<template>
  <div>
    <small v-if="theListType === 'latest'">Latest works</small>
    <ul class="latest-items" ref="latestList">
      <li 
        v-for="item in items"
        :key="item.slug"
        :class="item.slug"
      >
        <work-list-item :itemSlug="item.slug" :itemColor="item.projectColor" />
        <div>
          <h4>{{item.subject}}</h4>
          <p>{{item.year}} • {{item.participation}}</p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import axios from 'axios'
  import {TweenMax} from 'gsap'
  import ScrollMagic from 'scrollmagic'

  import WorkListItem from '@/components/WorkListItem.vue'

  export default {
    name: 'work-list',
    props: ['listType'],
    components: {'work-list-item': WorkListItem},
    data () {
      return {
        items: '',
        theListType: ''
      }
    },
    created () {
      let displayList = null

      axios.get('/static/data/works.json')
      .then((response) => {
        if (this.listType === 'latest') {
          displayList = response.data.projects.filter((work) => {
            if (!work.featured) {
              return work
            }
          })
        } else {
          displayList = response.data.projects
        }
        this.items = displayList
      })
      .catch((error) => {
        console.log(error)
      })
    },
    mounted () {
      this.theListType = this.listType
      TweenMax.from(this.$refs.latestList, 0.7, {opacity: 0, delay: 0.5})
    },
    updated () {
      const controller = new ScrollMagic.Controller()

      this.$refs.latestList.childNodes.forEach(item => {
        if (item.nodeType === Node.ELEMENT_NODE) {
          item.classList.add('mounted')

          new ScrollMagic.Scene({
            triggerElement: item,
            triggerHook: 'onEnter',
            offset: 200
          })
          .on('enter leave', (e) => {
            if (e.type === 'enter') {
              item.classList.add('reveal')
            } else {
              item.classList.remove('reveal')
            }
          })
          .addTo(controller)
        }
      })// forEach
    }
  }
</script>

<style lang="scss" scoped>
  ul {
    width: 100%;
    max-width: $size-max-width;
    display: grid;
    grid-gap: 40px;
    grid-template-columns: repeat(3, 1fr);

    @include device(tablet) {
      grid-gap: 30px;
      grid-template-columns: repeat(2, 1fr);
    }

    @include device(mobile) {
      grid-template-columns: repeat(1, 1fr);
    }
  }

  .mounted {
    opacity: 0;
    transform: translateY(50px);
    transition: all 0.5s ease-out;
    transition-property: opacity, transform;

    &.reveal {
      opacity: 1;
      transform: translateY(0);
    }
  }

  h4 {
    font-size: 1rem;
    margin-bottom: 0.5rem;
  }

  p {
    font-size: 0.9rem;
    font-style: normal;
    opacity: 0.5;
  }

</style>


// WEBPACK FOOTER //
// src/components/WorkList.vue